import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const ColumnTitle = ({ title }: { title: string }): ReactElement => {
  const { t } = useTranslation();

  return t(title);
};
